import { Grid } from "@mui/material";
import { ByzMuiDatePicker } from "../../mui/inputs/ByzMuiDatePicker";
import { useTranslate } from "src/locales";

interface Props {
  startDate: Date | null;
  endDate: Date | null;
  onStartChange: (d: Date | null) => void;
  onEndChange: (d: Date | null) => void;
}

export default function DateRangeFilter({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
}: Props) {
  const { t } = useTranslate();

  return (
    <>
      <Grid item xs={12} sm={6} md={2}>
        <ByzMuiDatePicker
          label={t("start-date")}
          value={startDate}
          onChange={onStartChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <ByzMuiDatePicker
          label={t("end-date")}
          value={endDate}
          onChange={onEndChange}
          fullWidth
        />
    </Grid>
    </>
  );
}
